<script setup lang="ts">
import { nextTick, onBeforeUnmount, onMounted, watch } from 'vue'
import { RouterView } from 'vue-router'
import { useRoute } from 'vue-router'
import { gsap } from 'gsap'
import AppSidebar from '@/components/AppSidebar.vue'
import FloatingProfessor from '@/components/FloatingProfessor.vue'
import { useAppStore } from '@/stores/app'

const store = useAppStore()
const route = useRoute()
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
function pageTargets(){return gsap.utils.toArray<HTMLElement>('.page-wrap > *')}
function animatePage(){if(reduceMotion.matches)return;nextTick(()=>{const targets=pageTargets();if(!targets.length)return;gsap.killTweensOf(targets);gsap.fromTo(targets,{opacity:.72,y:18},{opacity:1,y:0,duration:.62,stagger:.055,ease:'power3.out',clearProps:'opacity,transform'})})}
onMounted(()=>{store.initialize().catch(()=>undefined);const sidebar=document.querySelector<HTMLElement>('.sidebar');if(!reduceMotion.matches&&sidebar)gsap.fromTo(sidebar,{x:-24,opacity:.78},{x:0,opacity:1,duration:.7,ease:'power3.out',clearProps:'opacity,transform'});animatePage()})
watch(()=>route.fullPath,animatePage)
onBeforeUnmount(()=>{const targets=pageTargets();const sidebar=document.querySelector<HTMLElement>('.sidebar');if(targets.length)gsap.killTweensOf(targets);if(sidebar)gsap.killTweensOf(sidebar)})
</script>

<template>
  <div class="app-shell">
    <AppSidebar />
    <main class="app-main"><RouterView /></main>
    <FloatingProfessor v-if="!['/tutor', '/studio'].includes(route.path)" />
  </div>
</template>
